<template>
  <div class="home-why-choose">
    <div >
      <div class="row py-5">
        <div class="col-md-6 col-lg-4">
          <div class="card" @click="book">
            <div class="card-body">
              <div class="mb-4">
                <img :src="drive" width="40px" />
              </div>
              <h3 class="primary-color header-text-regular">BOOK A TEST DRIVE
                  <span class="headericon"><i class="el-icon-right"></i></span></h3>
             
              <p>Experience our automotive collection for yourself</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4">
          <div class="card" @click="aftersale">
            <div class="card-body">
              <div class="mb-4">
                <img :src="aftersales" width="40px" />
              </div>
              <h3 class="primary-color header-text-regular text-uppercase">After-Sales
                <span class="headericon"><i class="el-icon-right"></i></span></h3>
              <p>Premium after-sales to keep your vehicle running for years.</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4">
          <div class="card" @click="requests">
            <div class="card-body">
              <div class="mb-4">
                <img :src="request" width="50px" />
              </div>
              <h3 class="primary-color header-text-regular">REQUEST A QUOTE  <span class="headericon"><i class="el-icon-right"></i></span></h3>
              <p>Find a suitable deal to match your budget</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
var drive = require("../assets/img/drive.svg");
var aftersales = require("../assets/img/aftersales.svg");
var request = require("../assets/img/request.svg");

export default {
  name: "CoreValues",
  data() {
    return {
      drive: drive,
      aftersales: aftersales,
      request: request
    };
  },
  methods: {
 book(){
       this.$router.push("/book");
    },
     aftersale(){
       this.$router.push("/aftersales");
    },
 requests(){
       this.$router.push("/contact");
    },
  }
};
</script>